<template>
    <div class="toggle">
        
        
        
        
        
        <div class="toggle__button-container">
            <v-btn rounded="pill" class="d-flex text-transform-none h-100 text-13"
                :class="on ? 'toggle__button--selected' : 'toggle__button--unselected'" @click="on = true">
                Sign in
            </v-btn>


            <v-btn rounded="pill" class="d-flex text-transform-none h-100 text-13"
                :class="!on ? 'toggle__button--selected' : 'toggle__button--unselected'" @click="on = false">
                Sign up
            </v-btn>
        </div>





        <div class="toggle__content">
            <slot name="on" v-if="on"></slot>
            <slot name="off" v-else></slot>
        </div>



    </div>

</template>



<script setup>

import { inject } from 'vue';
let on = inject('on');

</script>